import { inject, Injectable } from '@angular/core';

import { PrivaLocalizationService } from '@priva/localization';

import { capitalizeText } from 'app/shared/utils';

import { ErrorScannedCode } from '../models';
import { getScannedCodeTitle } from '../utils';

@Injectable({ providedIn: 'root' })
export class FeedbackMessageService {
    privaLocalizationService = inject(PrivaLocalizationService);

    getScanNotificationMessage(error: ErrorScannedCode | undefined) {
        if (!error?.message) return '';

        let expectedCodeTypeTitle = '';
        if (typeof error?.expectedCodeType === 'string') {
            expectedCodeTypeTitle = this.privaLocalizationService.instant(error.expectedCodeType);
        } else {
            expectedCodeTypeTitle =
                error?.expectedCodeType && error?.expectedCodeType.length > 0
                    ? error.expectedCodeType
                          .map((code) => {
                              return this.privaLocalizationService.instant(getScannedCodeTitle(code));
                          })
                          .join('/')
                    : '';
            expectedCodeTypeTitle = capitalizeText(expectedCodeTypeTitle);
        }

        return this.privaLocalizationService.instant(error.message, {
            expectedCodeType: expectedCodeTypeTitle,
            scannedCodeType: error?.scannedCodeType
                ? this.privaLocalizationService.instant(error?.scannedCodeType).toLowerCase()
                : '',
            shortScannedValue: error?.shortScannedValue,
        });
    }
}
